import { useState } from 'react';

import Axios from 'axios';

import { forceReloadContactPlaylists, useEditPlaylistDocuments } from '@hooks/API/Contact/UseContactPlaylists';
import { forceReloadPackagePlaylist, useEditPackagePlaylistDocuments } from '@hooks/API/Packages/UsePackagePlaylist';
import { forceReloadPackage } from '@hooks/API/Packages/UsePackages';
import { forceReloadPlaylist } from '@hooks/API/UsePlaylist';

import { usePlaylistEditor } from './PlaylistEditorContext';
import { buildPlaylistDocuments } from './PlaylistEditorUtils';

/**
 * Salvataggio del book condiviso tra editor desktop e mobile: ordine dei
 * documenti, layout e invalidazioni delle query devono restare identici.
 */
const useSaveBook = () => {
    const { bookToEdit, bookToEditData, packageID, playlistItems, selectedModel, singlePage } = usePlaylistEditor();

    const { mutateAsync: editPlaylistDocuments } = useEditPlaylistDocuments();
    const { mutateAsync: editPackagePlaylistDocuments } = useEditPackagePlaylistDocuments();

    const [isSaving, setIsSaving] = useState(false);

    const saveBook = async () => {
        if (!bookToEdit || !bookToEditData) {
            return false;
        }
        setIsSaving(true);
        try {
            const updatedBook = {
                ID: bookToEdit,
                DocumentPlaylists: buildPlaylistDocuments(playlistItems, bookToEdit),
            };

            const bookLayout = singlePage ? 'Sequence' : 'Pages';
            if (bookToEditData.Layout !== bookLayout) {
                await Axios.put('/playlists/layout', {
                    PlaylistID: bookToEdit,
                    Layout: bookLayout,
                });
            }

            if (packageID) {
                await editPackagePlaylistDocuments({
                    playlist: updatedBook,
                    contactID: selectedModel,
                });
                forceReloadPackagePlaylist(updatedBook);
                forceReloadPackage(packageID);
            } else {
                await editPlaylistDocuments({
                    playlist: updatedBook,
                    contactID: selectedModel,
                });
                forceReloadPlaylist(bookToEdit);
                forceReloadContactPlaylists(selectedModel);
            }
            return true;
        } finally {
            setIsSaving(false);
        }
    };

    return { saveBook, isSaving };
};

export default useSaveBook;
